"use client";

import { FormProvider as RHFProvider } from "react-hook-form";

export default function FormProvider({ children, methods, onSubmit }) {
  return (
    <RHFProvider {...methods}>
      <form onSubmit={onSubmit} style={{ width: "100%" }}>
        {children}
      </form>
    </RHFProvider>
  );
}
